import React from 'react';

import { useTypedSelector } from '../../../../store/reducers/use-typed-selector';
import { OptionalComponent } from '../../../../utils/optional-component';
import { EIcon } from '../../../general-ui/icon/icon';

import './navigation-toggle.scss';

interface INavigationToggleProps {
	isDesktop?: boolean;
}

export default function NavigationToggle({ isDesktop }: INavigationToggleProps): JSX.Element {
	const hideControls = useTypedSelector(state => state.VideosReducer.showVideoControls);
	
	return (
		<OptionalComponent display={isDesktop && !hideControls}>
			<button className="no-style no-padding navigation-toggle">
				<EIcon name="menu" size="large" />
			</button>
		</OptionalComponent>
	);
}